<div class="home-wrapper">
  <div *ngFor="let config of items" class="home-box" [class.svg-icon]="config.svgIcon" [routerLink]="config.link">
    <mat-icon *ngIf="config.icon" class="home-box-icon material-icons-outlined" [fontIcon]="config.icon"></mat-icon>
    <img *ngIf="config.svgIcon" class="home-box-icon" [src]="config.svgIcon" />
    <span class="home-box-label">{{ config.labelKey | translate}}
      <ng-container *ngIf="config.extraLabel"> ({{ config.extraLabel }})</ng-container>
  </span>
  </div>
</div>



